module.exports = __webpack_public_path__ + "assets/img/elem4-transperent-bcg.4e463382.png";